module.exports = __webpack_public_path__ + "img/password_manager.fee15f0e.png";